import { Routes } from '@angular/router';

import { SearchStudentLayoutComponent } from './core/layouts/search-student-layout/search-student-layout.component';
import { StoreLayoutComponent } from './core/layouts/store-layout/store-layout.component';
import { storeGuard } from './core/security/guards/store.guard';

export const routes: Routes = [
  {
    path: '',
    component: StoreLayoutComponent,
    canActivate: [storeGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'livro-do-aluno'
      },
      {
        path: 'livro-do-aluno',
        title: 'Livro do aluno',
        loadComponent: () =>
          import('./features/home/pages/landing/landing.component').then(
            (c) => c.LandingComponent
          )
      }
    ]
  },
  {
    path: 'buscar-aluno',
    component: SearchStudentLayoutComponent,
    canActivate: [storeGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Buscar aluno',
        loadComponent: () =>
          import(
            './features/student/pages/search-student/search-student.component'
          ).then((c) => c.SearchStudentComponent)
      },
      {
        path: 'avancada',
        title: 'Busca avançada',
        loadComponent: () =>
          import(
            './features/student/pages/advanced-search/advanced-search.component'
          ).then((c) => c.AdvancedSearchComponent)
      },
      {
        path: 'token',
        title: 'Buscar pelo token',
        loadComponent: () =>
          import(
            './features/student/pages/search-by-token/search-by-token.component'
          ).then((c) => c.SearchByTokenComponent)
      }
    ]
  },
  {
    path: 'data-limite-expirada',
    title: 'Fim do período de compras',
    loadComponent: () =>
      import('./features/home/pages/limit-date/limit-date.component').then(
        (c) => c.LimitDateComponent
      )
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];
